import type { PublicProduct } from '@his/shared';

export interface CartLine {
  product: PublicProduct;
  qty: number;
}

const draftKey = (slug: string, branchId: string) => `his.public.cart.${slug}.${branchId}`;

export function readCartDraft(slug: string, branchId: string): CartLine[] {
  try {
    const raw = sessionStorage.getItem(draftKey(slug, branchId));
    if (!raw) return [];
    const parsed: unknown = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(
      (line): line is CartLine =>
        typeof line === 'object' && line !== null && typeof line.qty === 'number' && line.qty > 0 && typeof line.product?.id === 'string',
    );
  } catch {
    return [];
  }
}

export function writeCartDraft(slug: string, branchId: string, lines: CartLine[]): void {
  try {
    if (lines.length === 0) sessionStorage.removeItem(draftKey(slug, branchId));
    else sessionStorage.setItem(draftKey(slug, branchId), JSON.stringify(lines));
  } catch {
    return;
  }
}

export function clearCartDraft(slug: string, branchId: string): void {
  writeCartDraft(slug, branchId, []);
}

export function cartTotal(lines: CartLine[]): number {
  return lines.reduce((sum, line) => sum + line.product.priceMinor * line.qty, 0);
}
